var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtaShap3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 55,
    viewBox: "0 0 52 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.0596 55L24.9359 53.6403C13.09 39.0657 5.55178 29.1226 2.18063 21.4741C-2.68881 10.4263 1.80607 5.32726 4.00668 3.67009C7.79923 0.738163 13.6987 0.568238 18.7086 3.2877C22.1266 5.15734 24.7018 8.81159 26.2469 12.5084C30.8354 2.43785 37.5777 -0.621527 42.6813 0.10083C48.1126 0.823188 51.952 5.53976 51.9988 11.5736C52.1392 24.831 40.1061 38.7682 29.4776 51.0483L26.0596 55ZM11.264 3.88254C9.20388 3.88254 7.28417 4.43494 5.83271 5.58221C2.22745 8.34417 1.85287 13.7831 4.80263 20.4968C7.98649 27.6779 15.0097 37.0685 26.1064 50.7508L27.2302 49.4336C37.0627 38.0883 49.2831 23.9386 49.1427 11.5736C49.0958 6.857 46.2397 3.16019 42.2599 2.6078C37.9055 2.01291 31.3973 5.45475 27.4175 16.97L25.7787 21.729L24.7018 16.8425C23.8122 12.8483 21.0965 7.57935 17.2103 5.45477C15.2907 4.43497 13.2305 3.88254 11.264 3.88254Z",
    fill: "#3CCFB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaShap3);
export default __webpack_public_path__ + "static/media/cta-shap-3.35bc1188eb1172f371bd21e5b0b8245e.svg";
export { ForwardRef as ReactComponent };